module.exports = __webpack_public_path__ + "static/media/StayHome.2ddadc33.png";